import { IconName } from '@fortawesome/pro-solid-svg-icons';
import { IconType } from '@qpoint/icons';

export enum QPointMapMode {
  'Polyline' = 'polyline',
  'Polygon' = 'polygon'
}

export type QPointMapModeScope = string | 'all';

/**
 * QPointMapModeConfiguration
 * @description Configuration for a map mode
 * @property mode: QPointMapMode
 * @property multi: boolean - Whether the mode can be active with other modes
 * @property active: boolean - Whether the mode is currently active
 * @property tooltip: string - Tooltip for the mode
 * @property icon?: string | IconName - Icon for the mode
 * @property scope?: string - Scope for the mode (e.g. can be used to group polylines/polygons)
 * @property disabled?: boolean - Whether the mode is disabled
 */
export interface QPointMapModeConfiguration {
  mode: QPointMapMode;
  multi: boolean;
  active: boolean;
  tooltip: string;
  icon?: string | IconName;
  iconType?: IconType;
  scope?: QPointMapModeScope;
  disabled?: boolean;
  color?: string;
}
